import * as React from "react";
function SvgLayout3Cols(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        strokeWidth={2}
        stroke="currentColor"
        d="M1 5h30v22H1z"
      />
      <path strokeWidth={2} stroke="currentColor" d="M9 5v22M23 5v22" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgLayout3Cols);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
